<template v-if="is_checkout_one_time">
  <div v-if="pm_option == 'ASK_CUSTOMER'" class="cb-check cb-transition__fade">
    <template v-if="canAddNewPaymentMethod">
      <div class="cb-check__group">
        <div class="cb-check__left">
          <input
            type="checkbox"
            ref="x"
            class="cb-check__action cb-check__action--m-top"
            :value="retain_card"
            @change="onRetainCardChange"
            id="retain_card"
          />
        </div>
        <div class="cb-check__right">
          <label class="cb-check__label" for="retain_card">{{
            this.$store.getters.get_text(
              "hp_v3.paynow.use_card_future_payments"
            )
          }}</label>
          <div>
            {{
              t("pm.consent.txt", {
                organisation_name:
                  this.$store.state.config.organisation ||
                  this.$store.state.config.site,
              })
            }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cb-check__group">
        <div class="cb-check__left">
          <input
            type="checkbox"
            class="cb-check__action cb-check__action--m-top"
            ref="x"
            :value="replace_primary_pm"
            @change="onReplacePrimaryPmChange"
            id="replace_primary_pm"
          />
        </div>
        <div class="cb-check__right">
          <label for="replace_primary_pm" class="cb-check__label">{{
            this.$store.getters.get_text("hp_v3.paynow.replace_primary_source")
          }}</label>
          <div class="cb-check__help">
            {{
              this.$store.getters.get_text(
                "hp_v3.paynow.replace_primary_source.info"
              )
            }}
          </div>
        </div>
      </div>
    </template>
  </div>
  <div v-else-if="pm_option == 'ALWAYS'">
    <div class="cb-section__body">
      {{
        t("pm.consent.txt", {
          organisation_name:
            this.$store.state.config.organisation ||
            this.$store.state.config.site,
        })
      }}
    </div>
  </div>
  <div v-else-if="pm_option == 'NEVER'">
    <cb-notes :type="'info'" :message="t('pm.never.save.txt')"></cb-notes>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import CBNotification from "@/models/cb-notification";
import Notes from "@/components/collections/elements/Notes";
export default {
  components: {
    "cb-notes": Notes,
  },
  mounted() {
    if (!this.payment_method_type) {
      this.$store.dispatch(
        "set_current_notification",
        new CBNotification("error", {
          message: "Cannot proceed with a valid gateway account",
        })
      );
    }
  },
  computed: {
    ...mapGetters([
      "pm_authorized",
      "canAddNewPaymentMethod",
      "retain_pm_option",
      "is_checkout_one_time",
    ]),
    pm_option() {
      return this.$store.getters.retain_pm_option;
    },
    note() {
      return t("pm.consent.txt");
    },
  },
  props: [
    "editMode",
    "payment_method_type",
    "pm",
    "retain_card",
    "replace_primary_pm",
  ],
  methods: {
    onRetainCardChange(e) {
      this.$emit("change", { retain_card: e.target.checked });
    },
    onReplacePrimaryPmChange(e) {
      this.$emit("change", { replace_primary_pm: e.target.checked });
    },
  },
  data() {
    return {
      showLoader: false,
    };
  },
};
</script>
<style lang="stylus" scoped>
.cb-check__action--m-top {
  margin-top: 2px;
}
</style>
